import { render, staticRenderFns } from "./stockopname.vue?vue&type=template&id=17b99e12"
import script from "./stockopname.vue?vue&type=script&lang=js"
export * from "./stockopname.vue?vue&type=script&lang=js"
import style0 from "./stockopname.vue?vue&type=style&index=0&id=17b99e12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports